import React, { useState, useEffect } from "react";
import "./css/dashboard.css";
import { Breadcrumb, Layout, Menu, theme } from "antd";
import { BrowserRouter as Router, Route, Link } from "react-router-dom";

import Sidebar from "./sideBar"; // Import the Sidebar component
import CategoryReg from "./CategoryReg";

const { Header, Content, Footer } = Layout;

const Dashboard = () => {
    const [collapsed, setCollapsed] = useState(false);

    const toggleSidebar = () => {
        setCollapsed(!collapsed);
    };

    useEffect(() => {
        const handleWindowResize = () => {
            if (window.innerWidth <= 768) {
                setCollapsed(true);
            } else {
                setCollapsed(false);
            }
        };

        window.addEventListener("resize", handleWindowResize);

        return () => {
            window.removeEventListener("resize", handleWindowResize);
        };
    }, []);

    return (
        <Layout
            style={{
                minHeight: "10vh",
            }}
        >
            <Sidebar
                collapsed={collapsed}
                onCollapse={(value) => setCollapsed(value)}
            />
            <Layout className="layout2">
                <div className="contentH">
                    <div className="rowH">
                        <div className="col-sm-3 color1">
                            <Link
                                className="home-link"
                                to="/CategoryReg"
                                style={{ color: "#0098f1" }}
                            >
                                Category Registration
                            </Link>
                        </div>
                        <div className="col-sm-3 color2">
                            <Link
                                className="ledger-link"
                                to="/CategoryReg"
                                style={{ color: "#0098f1" }}
                            >
                                Ledger Registration
                            </Link>{" "}
                        </div>
                        <div className="col-sm-3 color3" style={{ color: "#0098f1" }}>
                            K O T
                        </div>
                    </div>
                    <div className="rowH" style={{ paddingTop: "10px" }}>
                        {/* <div className="col-sm-3 color5">Payment</div> */}
                        {/* <div className="col-sm-3 color6">Receipt</div> */}
                        {/* <div className="col-sm-3 color7">Journal</div> */}
                        <div
                            className="col-sm-3 color4"
                            to="/CategoryReg"
                            style={{ color: "#0098f1" }}
                        >
                            Sales
                        </div>
                        <div
                            className="col-sm-3 color8"
                            to="/CategoryReg"
                            style={{ color: "#0098f1" }}
                        >
                            Ledger
                        </div>
                        {/* </div> */}
                        {/* <div className="rowH" style={{ paddingTop: '10px' }}> */}
                        {/* <div className="col-sm-3 color9">Backup</div> */}
                        <div
                            className="col-sm-3 color11"
                            to="/CategoryReg"
                            style={{ color: "#0098f1" }}
                        >
                            Sales order
                        </div>
                    </div>
                </div>
            </Layout>
        </Layout>
    );
};
export default Dashboard;
